import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/pro-solid-svg-icons';

const FileArchiverInitialState = ({ onClick }) => (
  <a className="clickable" onClick={onClick}>
    <FontAwesomeIcon className="pr-2" icon={faDownload} size="lg" />
    Download All Files
  </a>
);

FileArchiverInitialState.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default FileArchiverInitialState;
